import { Stack, useMantineTheme } from '@mantine/core';

import type { BannerType as EnumBannerType } from '~/domains/common/components/Banner/Banner';
import { Banner } from '~/domains/common/components/Banner/Banner';

import type { BaseField, FieldDescriptor, StaticFieldProps } from '../../types/common';

export type BannerType = BaseField & {
  type: 'Banner';
  options: {
    type: EnumBannerType;
    message: string;
    visible: boolean;
  }[];
};

function BannerElement({ field }: StaticFieldProps<BannerType>) {
  const theme = useMantineTheme();

  return (
    <Stack spacing={theme.other.spacing._8}>
      {field.options.map((option) =>
        option.visible ? (
          <Banner key={option.message} allowClose type={option.type} message={option.message} />
        ) : null
      )}
    </Stack>
  );
}

const Descriptor: FieldDescriptor<BannerType> = {
  FieldComponent: BannerElement,
  name: 'Banner',
};

export default Descriptor;
